import React from "react";

const directionAngles = {
  right: 0,
  down: 90,
  left: 180,
  up: 270,
};

const rotation = (direction = "right") => {
  const angle = directionAngles[direction];
  return `rotate(${angle} 15 15)`;
};

const ArrowInCircle = props => (
  <svg viewBox="0 0 30 30" {...props}>
    <title>Arrow in a Circle Icon</title>
    <g transform={rotation(props.direction)}>
      <g style={{ mixBlendMode: "multiply" }}>
        <circle cx={15} cy={15} r={15} fill="currentColor" />
        <path
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={3}
          d="M13.19 11.14l2.18 2.13 2.18 2.12-2.24 2.06-2.24 2.06"
        />
      </g>
    </g>
  </svg>
);

export default ArrowInCircle;



// WEBPACK FOOTER //
// ./src/icons/ArrowInCircle.js